/**
 *
 * @author arman
 * @since 1/12/18
 *
 */
import React from 'react';
import Dialog from 'material-ui/Dialog';
import TextField from 'material-ui/TextField';
import FlatButton from 'material-ui/FlatButton';

const styles = {
  root: {

  },
  button: {
    height: '45px',
    width: '200px'
  }
};

const ReviewDialog = ({open, review, onChange, submitReview, toggleDialog, className, style}) => {
  const actions = [
    <FlatButton
      label="Cancel"
      secondary={true}
      onTouchTap={toggleDialog} />,
    <FlatButton
      label='Submit'
      primary={true}
      disabled={!review}
      backgroundColor='#D6D6D6'
      onTouchTap={submitReview} />
  ];

  return (
    <div className={className} style={{...styles.root, ...style}}>
      <Dialog
        modal={false}
        open={open}
        actions={actions}
        title='Mission Review'
        autoScrollBodyContent={true}
        onRequestClose={toggleDialog} >

        <div>
          <TextField
            hintText="review"
            floatingLabelText="Review"
            underlineShow={true}
            required={true}
            fullWidth={true}
            multiLine={true}
            rows={3}
            value={review}
            onChange={onChange.bind(null, 'review')}/> <br/><br/>
        </div>
      </Dialog>
    </div>
  );
};

export default ReviewDialog;


// WEBPACK FOOTER //
// ./src/screens/mission-view/review-dialog.component.js